var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRighticon = function SvgChevronRighticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.427 14.08a.25.25 0 0 1-.354 0l-.701-.7a.25.25 0 0 1 0-.354L9.64 8.757 5.372 4.49a.25.25 0 0 1 0-.354l.701-.701a.25.25 0 0 1 .354 0l5.146 5.146a.25.25 0 0 1 0 .354L6.427 14.08Z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronRighticon;